import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import i18n from './Utility/Translator/LanguageFile';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter basename="/pms" i18n={i18n}>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);
